import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import config from 'config'
import container from '../../helpers/container'
import {
  ContainerDivs,
  TargetDateGrid,
  // AssetManagerLetter,
  TargetDateSeriesNameHeader,
  PlanScorecardDefaultScorecard,
  TargetDateSeriesGradeDescription,
  TargetDateSeriesDoughnutChart,
  TargetDateSeriesCategoriesTable,
  TargetDateSeriesHoldingsLists,
  TargetDateSeriesPartnerLogos,
  TargetDateSeriesIssueLink,
  TargetDateSeriesMethodologyLink,
  TargetDateSeriesFullScorecard,
  TargetDateSeriesAllNamesTickers,
} from '../../components'
import Styles from './TargetDateSeries.css'

const iyvConfig = {
  fff: {
    id: 'fff',
    cats: [
      {
        lbl:  'Top 200 carbon reserve owners',
        cnt:  'c2_count',
        asst: 'c2_asset',
        wght: 'c2_weight',
        icon: require('../../../static/images/sectoricons/icn-is_c2.svg'),
        fld:  'is_c2'
      },
      {
        lbl:  'Coal industry',
        cnt:  'co_count',
        asst: 'co_asset',
        wght: 'co_weight',
        icon: require('../../../static/images/sectoricons/icn-is_co.svg'),
        fld:  'is_co'
      },
      {
        lbl:  'Oil/gas industry',
        cnt:  'og_count',
        asst: 'og_asset',
        wght: 'og_weight',
        icon: require('../../../static/images/sectoricons/icn-is_og.svg'),
        fld:  'is_og'
      },
      {
        lbl:  'Top 30 coal-fired utilities',
        cnt:  'mc50_count',
        asst: 'mc50_asset',
        wght: 'mc50_weight',
        icon: require('../../../static/images/sectoricons/icn-is_mc50.svg'),
        fld:  'is_mc50'
      },
      {
        lbl:  'Fossil-fired utilities',
        cnt:  'ut_count',
        asst: 'ut_asset',
        wght: 'ut_weight',
        icon: require('../../../static/images/sectoricons/icn-is_ut.svg'),
        fld:  'is_ut'
      },
      {
        lbl:  'All fossil fuel screens',
        cnt:  'fossil_fuel_count',
        asst: 'fossil_fuel_asset',
        wght: 'fossil_fuel_weight',
        // fld:  'is_fff'
      }
    ]
  },
  //
  ffb: {
    id: 'ffb',
    cats: [
      {
        lbl:  'Fossil fuel finance',
        cnt:  'fossil_bank_count',
        asst: 'fossil_bank_asset',
        wght: 'fossil_bank_weight',
        icon: require('../../../static/images/icons/ffb-icon.svg'),
        fld:  'is_fossil_bank'
      }
    ]
  },
  //
  ffi: {
    id: 'ffi',
    cats: [
      {
        lbl:  'Fossil fuel insurance',
        cnt:  'fossil_insure_count',
        asst: 'fossil_insure_asset',
        wght: 'fossil_insure_weight',
        icon: require('../../../static/images/icons/ffi-icon.svg'),
        fld:  'is_fossil_insure'
      }
    ]
  },
  //
  dff: {
    id: 'dff',
    cats: [
      {
        lbl:  'Deforestation-risk agribusiness',
        cnt:  'df_p_count',
        asst: 'df_p_asset',
        wght: 'df_p_weight',
        icon: require('../../../static/images/sectoricons/icn-is_df_p.svg'),
        fld:  'is_df_p'
      },
      {
        lbl:  'Deforestation-risk finance',
        cnt:  'df_f_count',
        asst: 'df_f_asset',
        wght: 'df_f_weight',
        icon: require('../../../static/images/sectoricons/icn-is_df_f.svg'),
        fld:  'is_df_f'
      },
      {
        lbl:  'Deforestation-risk consumer brands',
        cnt:  'df_c_count',
        asst: 'df_c_asset',
        wght: 'df_c_weight',
        icon: require('../../../static/images/sectoricons/icn-is_df_c.svg'),
        fld:  'is_df_c'
      },
      {
        lbl:  'All deforestation-risk screens',
        cnt:  'df_all_count',
        asst: 'df_all_asset',
        wght: 'df_all_weight',
      }
    ]
  },
  //
  gef: {
    id: 'gef',
  },
  //
  gff: {
    id: 'gff',
    cats: [
      {
        lbl:  'Gun manufacturers',
        cnt:  'wff_gun_manufacturers_count',
        asst: 'wff_gun_manufacturers_asset',
        wght: 'wff_gun_manufacturers_weight',
        icon: require('../../../static/images/sectoricons/icn-is_gm.svg'),
        fld:  'is_wff_gun_manufacturers'
      },
      {
        lbl:  'Gun retailers',
        cnt:  'wff_gun_retailers_count',
        asst: 'wff_gun_retailers_asset',
        wght: 'wff_gun_retailers_weight',
        icon: require('../../../static/images/sectoricons/icn-is_gr.svg'),
        fld:  'is_wff_gun_retailers'
      },
      {
        lbl:  'All civilian firearms screens',
        cnt:  'wff_civ_count',
        asst: 'wff_civ_asset',
        wght: 'wff_civ_weight',
      }
    ]
  },
  //
  pff: {
    id: 'pff',
    cats: [
      {
        lbl:  'Private prison operators',
        cnt:  'pff_extreme_count',
        asst: 'pff_extreme_asset',
        wght: 'pff_extreme_weight',
        icon: require('../../../static/images/sectoricons/icn-is_pff_extreme.svg'),
        fld:  'is_pff_extreme'
      },
      {
        lbl:  'Prison industrial complex, high-risk',
        cnt:  'pff_high_count',
        asst: 'pff_high_asset',
        wght: 'pff_high_weight',
        icon: require('../../../static/images/sectoricons/icn-is_pff_high.svg'),
        fld:  'is_pff_high'
      },
      {
        lbl:  'Prison industry',
        cnt:  'pff_prisons_count',
        asst: 'pff_prisons_asset',
        wght: 'pff_prisons_weight',
        icon: require('../../../static/images/sectoricons/icn-is_prisons.svg'),
        fld:  'is_pff_prisons'
      },
      {
        lbl:  'Border industry',
        cnt:  'pff_borders_count',
        asst: 'pff_borders_asset',
        wght: 'pff_borders_weight',
        icon: require('../../../static/images/sectoricons/icn-is_borders.svg'),
        fld:  'is_pff_borders'
      },
      {
        lbl:  'All prison industrial complex screens',
        cnt:  'pff_all_count',
        asst: 'pff_all_asset',
        wght: 'pff_all_weight',
      }
    ]
  },
  //
  wff: {
    id: 'wff',
    cats: [
      {
        lbl:  'Nuclear weapons',
        cnt:  'wff_nuclear_weapons_count',
        asst: 'wff_nuclear_weapons_asset',
        wght: 'wff_nuclear_weapons_weight',
        icon: require('../../../static/images/sectoricons/icn-is_nw.svg'),
        fld:  'is_wff_nuclear_weapons'
      },
      {
        lbl:  'Controversial weapons',
        cnt:  'wff_cluster_munitions_count',
        asst: 'wff_cluster_munitions_asset',
        wght: 'wff_cluster_munitions_weight',
        icon: require('../../../static/images/sectoricons/icn-is_cm.svg'),
        fld:  'is_wff_cluster_munitions'
      },
      {
        lbl:  'All military contractors',
        cnt:  'wff_major_military_contractors_count',
        asst: 'wff_major_military_contractors_asset',
        wght: 'wff_major_military_contractors_weight',
        icon: require('../../../static/images/sectoricons/icn-is_mmc.svg'),
        fld:  'is_wff_major_military_contractors'
      },
      // {
      //   lbl:  'All military weapons screens',
      //   cnt:  'wff_mil_count',
      //   asst: 'wff_mil_asset',
      //   wght: 'wff_mil_weight',
      // }
    ]
  },
  //
  tff: {
    id: 'tff',
    cats: [
      {
        lbl:  'Tobacco producers',
        cnt:  't_count',
        asst: 't_asset',
        wght: 't_weight',
        icon: require('../../../static/images/sectoricons/icn-is_t.svg'),
        fld:  'is_t'
      },
      {
        lbl:  'Tobacco-promoting entertainment studios',
        cnt:  't_m_count',
        asst: 't_m_asset',
        wght: 't_m_weight',
        icon: require('../../../static/images/sectoricons/icn-is_t_m.svg'),
        fld:  'is_t_m'
      },
      {
        lbl:  'All tobacco screens',
        cnt:  't_all_count',
        asst: 't_all_asset',
        wght: 't_all_weight',
        // fld:  'is_fff'
      }
    ]
  }
}


@CSSModules(Styles, {allowMultiple:true})
export default class TargetDateSeries extends Component {
  static propTypes = {
  }
  static contextTypes =  {
    router: PropTypes.object.isRequired
  }
  constructor(props) {
    super(props)
    this.state = {
      strategyName: ((props.params.strategyName) ? props.params.strategyName : ''),
      showFundDetails: false,
      activeIssue: 'fossil', // config.app.title,
      pageDescription: 'See how target date funds popular in employee retirement plans are rated on environmental and social sustainability issues.'
    }
  }
  componentWillMount() {
    this.scrollTop()
    this.setState({ activeIssue: this.initActiveIssue(this.props) })
  }
  componentWillReceiveProps(props) {
    // if new target date fund
    if (props.params.strategyName !== this.state.strategyName) {
      this.scrollTop()
      this.setState(
        {
          strategyName: props.params.strategyName || '',
          showFundDetails: false,
          activeIssue: this.initActiveIssue(this.props)
        }
      )
    }
    // if new query issue
    if (
      props.location.query &&
      props.location.query.issue &&
      props.location.query.issue !== this.state.activeIssue
    ) {
      this.scrollTop()
      this.setState({ activeIssue: this.initActiveIssue(props) })
    }
  }

  scrollTop = () => {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  initActiveIssue = (props=false) => {
    const issues = [
      'fossil',
      'fossil-fuel-lending',
      'fossil-fuel-insurance',
      'deforestation',
      'gender-equality',
      'guns',
      'prison-industrial-complex',
      'military-weapons',
      'tobacco'
    ]
    // const sitenames = [
    //   'Fossil Free Funds',
    //   'Deforestation Free Funds',
    //   'Gender Equality Funds',
    //   'Guns Free Funds',
    //   'Prison Free Funds',
    //   'Weapon Free Funds',
    //   'Tobacco Free Funds'
    // ]
    let activeIssue = 'fossil'
    if (
      props &&
      props.location &&
      props.location.query &&
      props.location.query.issue &&
      issues.includes(props.location.query.issue)
    ) {
      activeIssue = props.location.query.issue
    }
    // else if (sitenames.includes(config.app.title)) {
    //   activeIssue = {
    //     'Fossil Free Funds': 'fossil',
    //     'Deforestation Free Funds': 'deforestation',
    //     'Gender Equality Funds': 'gender-equality',
    //     'Guns Free Funds': 'guns',
    //     'Prison Free Funds': 'prison-industrial-complex',
    //     'Weapon Free Funds': 'military-weapons',
    //     'Tobacco Free Funds': 'tobacco'
    //   }[config.app.title]
    // }
    return activeIssue
  }

  configTargetDateSeries = () => {
    return config.targetDateSeries.find(
      (series) => series.strategy_name_query === this.state.strategyName
    )
  }

  render() {
    if (!this.props.params.strategyName) {
      return (
        <div styleName='main-grid'>
          {
            container.helmet(
              'Target date funds',
              this.state.pageDescription,
              config.app.domain + config.routes.targetDateFunds
            )
          }
          <TargetDateGrid page/>
        </div>
      )
    }

    const targetDateSeries = this.configTargetDateSeries()
    if (!targetDateSeries){
      return (
        <div styleName='main-grid'>
          {
            container.helmet(
              'Target date funds',
              this.state.pageDescription,
              config.app.domain + config.routes.targetDateFunds
            )
          }
          <TargetDateGrid page/>
        </div>
      )
    }

    const icons = {
      fff: require( '../../../static/images/icons/fff-icon.svg' ),
      ffb: require( '../../../static/images/icons/ffb-icon.svg' ),
      ffi: require( '../../../static/images/icons/ffi-icon.svg' ),
      dff: require( '../../../static/images/icons/dff-icon.svg' ),
      gef: require( '../../../static/images/icons/gef-icon.svg' ),
      gff: require( '../../../static/images/icons/gff-icon.svg' ),
      pff: require( '../../../static/images/icons/pff-icon.svg' ),
      wff: require( '../../../static/images/icons/wff-icon.svg' ),
      tff: require( '../../../static/images/icons/tff-icon.svg' )
    }
    const iconsColor = {
      fff: require( '../../../static/images/icons/fff-icon-white.svg' ),
      ffb: require( '../../../static/images/icons/ffb-icon-white.svg' ),
      ffi: require( '../../../static/images/icons/ffi-icon-white.svg' ),
      dff: require( '../../../static/images/icons/dff-icon-white.svg' ),
      gef: require( '../../../static/images/icons/gef-icon-white.svg' ),
      gff: require( '../../../static/images/icons/gff-icon-white.svg' ),
      pff: require( '../../../static/images/icons/pff-icon-white.svg' ),
      wff: require( '../../../static/images/icons/wff-icon-white.svg' ),
      tff: require( '../../../static/images/icons/tff-icon-white.svg' )
    }

    // these will change based on which of 7 sites we're on
    let thisConfig = {}
    switch (this.state.activeIssue){
      case 'fossil':
        thisConfig = iyvConfig.fff
        break

      case 'fossil-fuel-lending':
        thisConfig = iyvConfig.ffb
        break

      case 'fossil-fuel-insurance':
        thisConfig = iyvConfig.ffi
        break

      case 'deforestation':
        thisConfig = iyvConfig.dff
        break

      case 'gender-equality':
        thisConfig = iyvConfig.gef
        break

      case 'guns':
        thisConfig = iyvConfig.gff
        break

      case 'prison-industrial-complex':
        thisConfig = iyvConfig.pff
        break

      case 'military-weapons':
        thisConfig = iyvConfig.wff
        break

      case 'tobacco':
        thisConfig = iyvConfig.tff
        break
    }

    //
    return (
      <div styleName='main'>
        {
          container.helmet(
            targetDateSeries.strategy_name,
            `See how ${targetDateSeries.strategy_name} is rated on environmental and social sustainability issues.`,
            config.domain + config.routes.targetDateFunds + '/' +
              this.state.strategyName
          )
        }
        <div styleName='page-background'>
          <ContainerDivs>

            { /* <AssetManagerLetter fundFamilyName={targetDateSeries.fund_family_label}/> */ }

            { /* Name, logo, and link to target date nav grid */ }
            <TargetDateSeriesNameHeader
              targetDateSeries={targetDateSeries}
            />

            <PlanScorecardDefaultScorecard fund={targetDateSeries} notPlan/>

            { /* Nav bar for target date series, 7 issues */ }
            <nav styleName='nav-flex'>
              {
                // Add 'gef' back when SJF is online
                ['fff','ffb','ffi','dff','gff','pff','wff','tff'].map((e, i) => {
                  const sitename = {
                    fff: 'fossil',
                    ffb: 'fossil-fuel-lending',
                    ffi: 'fossil-fuel-insurance',
                    dff: 'deforestation',
                    gef: 'gender-equality',
                    gff: 'guns',
                    pff: 'prison-industrial-complex',
                    wff: 'military-weapons',
                    tff: 'tobacco'
                  }[e]
                  return (
                    <button
                      key={'nav-item-'+i}
                      styleName='nav-item'
                      onClick={
                        () => {
                          if (this.state.activeIssue!==sitename){
                            this.setState({activeIssue:sitename})

                            this.context.router.push({
                              pathname: config.routes.targetDateFunds + '/' +
                                this.state.strategyName,
                              query: {
                                issue: sitename
                              }
                            })
                          }
                        }
                      }
                    >
                      <img
                        src={
                          this.state.activeIssue===sitename ?
                            iconsColor[e] :
                            icons[e]
                        }
                        alt={sitename}
                        styleName={this.state.activeIssue===sitename ? 'nav-img-actv' : 'nav-img'}
                      />
                    </button>
                  )
                })
              }
            </nav>

            { /* Description of the grade earned for this issue */ }
            <TargetDateSeriesGradeDescription
              iyvCode={thisConfig.id}
              targetDateSeries={targetDateSeries}
            />

            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            { /*   Doughnut chart, categories table, holdings list,       */ }
            { /*     methodology link for this target date series and     */ }
            { /*     selected issue. Hidden if active issue is GEF.       */ }
            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            <div>
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
              { /*   Doughnut chart and taglines describing stats   */ }
              { /*     for this issue. Repeated X times, this is    */ }
              { /*     a hack to fix a bug with the doughnuts.      */ }
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
              {
                this.state.activeIssue === 'fossil' ?
                  (
                    <TargetDateSeriesDoughnutChart
                      iyvCode={thisConfig.id}
                      targetDateSeries={targetDateSeries}
                    />
                  ) :
                  null
              }

              {
                this.state.activeIssue === 'fossil-fuel-lending' ?
                  (
                    <div>
                      <br/>
                      <br/>
                      <br/>
                      <br/>
                    </div>
                  ) :
                  null
              }

              {
                this.state.activeIssue === 'fossil-fuel-insurance' ?
                  (
                    <div>
                      <br/>
                      <br/>
                      <br/>
                      <br/>
                    </div>
                  ) :
                  null
              }

              {
                this.state.activeIssue === 'deforestation' ?
                  (
                    <TargetDateSeriesDoughnutChart
                      iyvCode={thisConfig.id}
                      targetDateSeries={targetDateSeries}
                    />
                  ) :
                  null
              }

              {
                this.state.activeIssue === 'gender-equality' ?
                  (
                    <div/>
                  ) :
                  null
              }

              {
                this.state.activeIssue === 'guns' ?
                  (
                    <TargetDateSeriesDoughnutChart
                      iyvCode={thisConfig.id}
                      targetDateSeries={targetDateSeries}
                    />
                  ) :
                  null
              }

              {
                this.state.activeIssue === 'prison-industrial-complex' ?
                  (
                    <TargetDateSeriesDoughnutChart
                      iyvCode={thisConfig.id}
                      targetDateSeries={targetDateSeries}
                    />
                  ) :
                  null
              }

              {
                this.state.activeIssue === 'military-weapons' ?
                  (
                    <TargetDateSeriesDoughnutChart
                      iyvCode={thisConfig.id}
                      targetDateSeries={targetDateSeries}
                    />
                  ) :
                  null
              }

              {
                this.state.activeIssue === 'tobacco' ?
                  (
                    <TargetDateSeriesDoughnutChart
                      iyvCode={thisConfig.id}
                      targetDateSeries={targetDateSeries}
                    />
                  ) :
                  null
              }

              {/* GEF has no category table or holdings list */}
              {
                this.state.activeIssue !== 'gender-equality' ?
                  (
                    <div>
                      { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/ }
                      { /*   Table listing stats for each category in     */ }
                      { /*     this issue                                 */ }
                      { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
                      <TargetDateSeriesCategoriesTable
                        iyvConfigCategories={thisConfig.cats}
                        targetDateSeries={targetDateSeries}
                      />

                      { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
                      { /*   A list of top 5 flagged holdings for each    */ }
                      { /*     category in this issue                     */ }
                      { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
                      <TargetDateSeriesHoldingsLists
                        iyvConfigCategories={thisConfig.cats}
                        targetDateSeries={targetDateSeries}
                      />
                    </div>
                  ) : null
              }
            </div>

            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            { /*   Link to methodology page for this issue        */ }
            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            <TargetDateSeriesMethodologyLink
              targetDateSeries={targetDateSeries}
              iyvCode={thisConfig.id}
              linkType='fullProfile'
            />

            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            { /*   Link to methodology page for this issue                */ }
            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            <TargetDateSeriesMethodologyLink
              targetDateSeries={targetDateSeries}
              iyvCode={thisConfig.id}
              linkType='methodology'
            />

            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            { /*   Link to the static page describing this issue          */ }
            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            <TargetDateSeriesIssueLink iyvCode={thisConfig.id} />

            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            { /*   Logos of partners and data sources for this issue      */ }
            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            <TargetDateSeriesPartnerLogos iyvCode={thisConfig.id}/>

            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            { /*   Full scorecard of all issues for this target date      */ }
            { /*     series                                               */ }
            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            <TargetDateSeriesFullScorecard
              targetDateSeries={targetDateSeries}
            />

            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            { /*   List of all names and tickers associated with this     */ }
            { /*     target date series                                   */ }
            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            <TargetDateSeriesAllNamesTickers
              targetDateSeries={targetDateSeries}
            />

            <br/>
            <br/>
            <br/>
          </ContainerDivs>
        </div>
      </div>
    )
  }
}
